'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');

var CarmiContext = React.createContext(null);

var privatesByPointer = new WeakMap();
var pointerByInstance = new WeakMap();

function getPrivatesByPointer(pointer) {
  if (!privatesByPointer.has(pointer)) {
    var privates = {
      descriptorToCompsMap: new WeakMap(),
      descriptorToElementsMap: new WeakMap(),
      pendingFlush: new Set(),
      compsLib: {},
      root: null,
      flush: function flush() {
        if (privates.root.lastChildren !== privates.root.props.children()) {
          privates.root.setState({});
        }
        privates.pendingFlush.forEach(function (comp) {
          comp.setState({});
        });
        privates.pendingFlush.clear();
      }
    };
    privatesByPointer.set(pointer, privates);
  }
  return privatesByPointer.get(pointer);
}

function createPointerToInstanceIfNeeded(instance) {
  if (!pointerByInstance.has(instance)) {
    pointerByInstance.set(instance, {});
  }
}

function getPrivatesByInstance(instance) {
  createPointerToInstanceIfNeeded(instance);
  return getPrivatesByPointer(pointerByInstance.get(instance));
}

function getPointerToInstance(instance) {
  createPointerToInstanceIfNeeded(instance);
  return pointerByInstance.get(instance);
}

var CarmiRoot = function (_React$Component) {
  _inherits(CarmiRoot, _React$Component);

  function CarmiRoot(props) {
    _classCallCheck(this, CarmiRoot);

    var _this = _possibleConstructorReturn(this, (CarmiRoot.__proto__ || Object.getPrototypeOf(CarmiRoot)).call(this, props));

    _this.lastChildren = null;
    return _this;
  }

  _createClass(CarmiRoot, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(newProps) {
      return newProps.children() !== this.lastChildren;
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(CarmiContext.Provider, {
        children: this.props.children()
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var privates = getPrivatesByInstance(this.props.value);
      privates.root = this;
      this.lastChildren = this.props.children();
      this.props.value.$addListener(privates.flush);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.lastChildren = this.props.children();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var privates = getPrivatesByInstance(this.props.value);
      this.props.value.$removeListener(privates.flush);
    }
  }]);

  return CarmiRoot;
}(React.Component);

var BUILT_IN_PROPS = {
  origKey: true,
  key: true,
  ref: true,
  descriptor: true,
  type: true,
  dirtyFlag: true,
  token: true
};

var CarmiObserver = function (_React$Component2) {
  _inherits(CarmiObserver, _React$Component2);

  function CarmiObserver() {
    _classCallCheck(this, CarmiObserver);

    return _possibleConstructorReturn(this, (CarmiObserver.__proto__ || Object.getPrototypeOf(CarmiObserver)).apply(this, arguments));
  }

  _createClass(CarmiObserver, [{
    key: 'render',
    value: function render() {
      this.props.dirtyFlag[0] = false;
      var descriptor = this.props.descriptor;

      var _parseDescriptor = parseDescriptor(descriptor),
          type = _parseDescriptor.type,
          children = _parseDescriptor.children,
          originalProps = _parseDescriptor.props;

      var props = null;
      if (originalProps || this.props.overrides) {
        props = originalProps ? _extends({}, originalProps, this.props.overrides) : this.props.overrides;
        if (props.hasOwnProperty('style')) {
          props.style = _extends({}, props.style);
        }
      }
      var privates = getPrivatesByPointer(this.props.token);
      var Component = privates.compsLib[type] || type;
      return React.createElement.apply(React, [Component, props].concat(_toConsumableArray(children)));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var privates = getPrivatesByPointer(this.props.token);
      if (!privates.descriptorToCompsMap.has(this.props.descriptor)) {
        privates.descriptorToCompsMap.set(this.props.descriptor, new Set());
      }
      privates.descriptorToCompsMap.get(this.props.descriptor).add(this);
      if (this.props.dirtyFlag[0]) {
        this.setState({});
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.dirtyFlag[0]) {
        this.setState({});
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var privates = getPrivatesByPointer(this.props.token);
      privates.pendingFlush.delete(this);
      if (!privates.descriptorToCompsMap.has(this.props.descriptor)) {
        privates.descriptorToCompsMap.set(this.props.descriptor, new Set());
      }
      privates.descriptorToCompsMap.get(this.props.descriptor).delete(this);
    }
  }]);

  return CarmiObserver;
}(React.Component);

CarmiObserver.contextType = CarmiContext;

function Provider(_ref) {
  var children = _ref.children,
      value = _ref.value,
      _ref$compsLib = _ref.compsLib,
      compsLib = _ref$compsLib === undefined ? {} : _ref$compsLib;

  var privates = getPrivatesByInstance(value);
  privates.compsLib = compsLib;
  return React.createElement(CarmiRoot, { children: children, value: value });
}

function getMaybeKey(props, name) {
  return props && props.hasOwnProperty(name) ? props[name] : null;
}

function replaceElementProps(element, newProps) {
  Object.assign(element.props, newProps);
  Object.keys(element.props).forEach(function (prop) {
    if (!newProps.hasOwnProperty(prop) && !BUILT_IN_PROPS.hasOwnProperty(prop)) {
      delete element.props[prop];
    }
  });
}

function parseDescriptor(descriptor) {
  var type = descriptor[0];
  var props = descriptor[1] || {};
  var children = descriptor.slice(2);
  var childrenList = children && Array.isArray(children[0]) && children.length === 1 ? children[0] : children;

  var rawKey = props.key,
      extraProps = _objectWithoutProperties(props, ['key']);

  var key = getMaybeKey(props, 'key');
  return { type: type, props: props, children: children, childrenList: childrenList, rawKey: rawKey, extraProps: extraProps, key: key };
}

var wrapElement = function wrapElement(wrappers, element, children) {
  return wrappers.reduce(function (wrappedElement, wrapper) {
    return wrapper(wrappedElement, children);
  }, element);
};

function getOverrides(originalProps, props) {
  var overrides = null;
  Object.keys(props).forEach(function (prop) {
    if (!BUILT_IN_PROPS.hasOwnProperty(prop) && originalProps[prop] !== props[prop]) {
      overrides = overrides || {};
      overrides[prop] = props[prop];
    }
  });
  return overrides;
}

function createNewElement(observerProps, props) {
  var rawKey = props.key,
      extraProps = _objectWithoutProperties(props, ['key']);

  var type = React.forwardRef(function (forwardProps, forwardedRef) {
    var overrides = getOverrides(props, forwardProps);
    return React.createElement(CarmiObserver, _extends({}, observerProps, { overrides: overrides, forwardedRef: forwardedRef }));
  });
  var compProps = _extends({}, observerProps, extraProps);
  var rawElement = React.createElement(type, compProps);
  // sorry about doing it but
  // we short circuit the reconciliation code of React
  // and we need to mutate the props in place
  // so a parent component that is aware of the expected props
  // of a child can access them, even if they changed since the
  // last time React.createElement was triggered
  var element = _extends({}, rawElement);
  element.props = _extends({}, rawElement.props);

  return element;
}

function _createElement(wrappers, descriptor) {
  var _parseDescriptor2 = parseDescriptor(descriptor),
      type = _parseDescriptor2.type,
      props = _parseDescriptor2.props,
      childrenList = _parseDescriptor2.childrenList,
      extraProps = _parseDescriptor2.extraProps,
      key = _parseDescriptor2.key;

  var privates = getPrivatesByInstance(this);
  var currentElement = privates.descriptorToElementsMap.get(descriptor);
  if (currentElement && currentElement.props.type === type && getMaybeKey(currentElement.props, 'origKey') === key) {
    // Element is mounted
    currentElement.props.dirtyFlag[0] = true;
    if (privates.descriptorToCompsMap.get(descriptor)) {
      privates.descriptorToCompsMap.get(descriptor).forEach(function (comp) {
        return privates.pendingFlush.add(comp);
      });
    }
    replaceElementProps(currentElement, extraProps);
  } else {
    var dirtyFlag = [true];
    var observerProps = { descriptor: descriptor, type: type, dirtyFlag: dirtyFlag, token: getPointerToInstance(this) };
    if (key !== null) {
      observerProps.origKey = key;
      observerProps.key = key;
    }
    var newElement = createNewElement(observerProps, props);
    privates.descriptorToElementsMap.set(descriptor, newElement);
  }
  var element = privates.descriptorToElementsMap.get(descriptor);
  return wrapElement(wrappers, element, childrenList);
}

function getFunctionsLibrary() {
  var customWrappers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return {
    createElement: function createElement(descriptor) {
      return _createElement.call(this, customWrappers, descriptor);
    }
  };
}

module.exports = {
  carmiReactFnLib: getFunctionsLibrary(),
  getFunctionsLibrary: getFunctionsLibrary,
  Provider: Provider
};
//# sourceMappingURL=index.js.map